  //-----------------------
  // React basic Components
  //-----------------------
  import React                                               from "react";
  import PropTypes                                           from "prop-types";
//import { NavLink }                                         from "react-router-dom";
  import { connect }                                         from "react-redux";
  //-----------------------------
  // @material-ui/core components
  //-----------------------------
  import withStyles                                          from "@material-ui/core/styles/withStyles";
  import Button                                              from '@material-ui/core/Button';
  import TextField                                           from '@material-ui/core/TextField';
//import Checkbox                                            from '@material-ui/core/Checkbox';
  import CircularProgress                                    from "@material-ui/core/CircularProgress";
//import AccountCircleIcon                                   from "@material-ui/icons/AccountCircle";
  import Dialog                                              from '@material-ui/core/Dialog';
  import DialogActions                                       from '@material-ui/core/DialogActions';
  import DialogContent                                       from '@material-ui/core/DialogContent';
  import DialogContentText                                   from '@material-ui/core/DialogContentText';
  import DialogTitle                                         from '@material-ui/core/DialogTitle';
  import Slide                                               from '@material-ui/core/Slide';
//import FormControlLabel                                    from '@material-ui/core/FormControlLabel';
  import InputLabel                                          from '@material-ui/core/InputLabel';
  import MenuItem                                            from '@material-ui/core/MenuItem';
//import FormHelperText                                      from '@material-ui/core/FormHelperText';
  import FormControl                                         from '@material-ui/core/FormControl';
  import Select                                              from '@material-ui/core/Select';
  import Autocomplete                                        from '@material-ui/lab/Autocomplete';
  import { createFilterOptions }                             from '@material-ui/lab/Autocomplete';
//import Divider                                             from '@material-ui/core/Divider';
  //[SNACKBAR]
  import Snackbar                                            from '@material-ui/core/Snackbar';
  import MuiAlert                                            from '@material-ui/lab/Alert';
  //[POPOVER]
  import Popover                                             from '@material-ui/core/Popover';
  import IconButton                                          from '@material-ui/core/IconButton';
//import InputAdornment                                      from '@material-ui/core/InputAdornment';
  import Typography                                          from '@material-ui/core/Typography';
  import InfoIcon                                            from '@material-ui/icons/Info';
  //------------------
  // Custom components
  //------------------
  import GridContainer                                       from "components/Grid/GridContainer.jsx";
  import GridItem                                            from "components/Grid/GridItem.jsx";
  import CustomButton                                        from "components/CustomButtons/Button.jsx";
//import CustomInput                                         from "components/CustomInput/CustomInput.jsx";
//import CustomDropdown                                      from "components/CustomDropdown/CustomDropdown.jsx";
  //------------
  // WebServices
  //------------
  import { history }                                         from "../../_helpers";
  import { api }                                             from "../../_constants";
  import { wu_StaticDataService }                            from "../../_services";
  import { wu_Utilities }                                    from "../../_services";
  import { wu_CountriesStatesCitiesService }                 from "../../_services";
  import { wu_CurrenciesService }                            from "../../_services";
  import { wu_HistoryService }                               from "../../_services";
  import { wu_OnlineMTService }                              from "../../_services";
  //------
  // Style
  //------
  import HistoryRefundStyle                                  from "./HistoryRefundStyle.jsx";
  //-------
  // images
  //-------
  import logo                                                from "assets/img/wu/WU_CONTENT_main_symbol_left.svg";
  import KeyboardBackspaceIcon                               from '@material-ui/icons/KeyboardBackspace'; //[goBack]
  //----------
  // variables
  //----------
  const filename = "HistoryRefund ";
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });
  //[SNACKBAR]
  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  const filePreviewSizeKB_MAX_5_0_mb = 10*512; //5.0 mb

  //[flagsimages]
  var images = null;

class HistoryRefund extends React.Component {
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Basic Methods-------------------------------------
  //----------------------------------------------------------------------------------------------------
  constructor(props) {
    let methName = filename+"constructor ";
    if(api.print_logs){console.log(methName+props);}

    super(props);
    this.state = {
      dialog_msg                                           : "",
      dialog_isOpen                                        : false,

      //[DialogSpinner]
      dialog200_msg                                        : "",
      dialog200_isOpen                                     : false,

      viewPleaseWait_hidden                                : true,

      //[SNACKBAR]
      Snackbar_textField_open                              : false,
      Snackbar_textField_msg                               : "",

      textField1                                           : "",
      textField1_hasError                                  : false,
      textField2                                           : "",
      textField2_hasError                                  : false,
      textField3                                           : "",
      textField3_hasError                                  : false,

      picker2_selIndex                                     : 0,  //2-Country
      picker2_textFieldLabel1_id                           : "",
      picker2_textFieldLabel1_text                         : "",
      picker2_textFieldLabel1_hasError                     : false,
      picker2_textFieldLabel1_AUTOCOMPLETE_MODE            : "object", //"text","object";
      picker2_textFieldLabel1_AUTOCOMPLETE_FILTER_OPTIONS  : "any",    //"start","any"
      picker3_selIndex_currencyReceive                     : 0,  //3-Receive Currency
      picker3_textFieldLabel1_id                           : "",
      picker3_textFieldLabel1_text                         : "",
      picker3_textFieldLabel1_hasError                     : false,
      picker4_selIndex_State                               : 0,  //4-State
      picker4_textFieldLabel1_text                         : "",
      picker4_textFieldLabel1_id                           : "",
      picker4_textFieldLabel1_hasError                     : false,
      picker5_selIndex_City                                : 0,  //5-City
      picker5_textFieldLabel1                              : "",
      picker5_textFieldLabel1_id                           : "",
      picker5_textFieldLabel1_hasError                     : false,

      viewState_isHidden                                   : true,
      viewCity_isHidden                                    : true,
      viewStateCity_isHidden                               : true,

      parserObject_getCountries                            : [],
      parserObject_getCountries4Picker                     : [],
      parserObject_getCities                               : [],
      parserObject_getCities4Picker                        : [],
      parserObject_getStates                               : [],
      parserObject_getStates4Picker                        : [],
      parserObject_getCurrencies_ALL                       : [],
      parserObject_getCurrencies                           : [],
      parserObject_getCurrencies4Picker                    : [],

      "fileDocument1"                                      : null,
      "filePreviewSizeKB"                                  : 0,

      dialog2_msg                                          : "",
      dialog2_isOpen                                       : false,

      dialog3_msg                                          : "",
      dialog3_isOpen                                       : false,

      //[POPOVER]
      receiptDoc_popover_isOpen                            : false,
    };
    //------------
    //translations
    //------------
    this.texts_gr = wu_StaticDataService.wu_getLocales_gr({});
    this.texts_en = wu_StaticDataService.wu_getLocales_en({});
    //--------
    //bindings
    //--------
    this.verifyGenericItem                                 = this.verifyGenericItem.bind(this);
    this.dialog_handleClose                                = this.dialog_handleClose.bind(this);
    this.startSpinners                                     = this.startSpinners.bind(this);
    this.stopSpinners                                      = this.stopSpinners.bind(this);

    //[DialogSpinner]
    this.dialog200_handleOpen                              = this.dialog200_handleOpen.bind(this);
    this.dialog200_handleClose                             = this.dialog200_handleClose.bind(this);

    //[goBack]
    this.goBack                                            = this.goBack.bind(this);

    //[SNACKBAR]
    this.Snackbar_textField_handleOpen                     = this.Snackbar_textField_handleOpen.bind(this);
    this.Snackbar_textField_handleClose                    = this.Snackbar_textField_handleClose.bind(this);

    this.handleCustomDropDownClick_country                 = this.handleCustomDropDownClick_country.bind(this);
    this.handleCustomDropDownClick_state                   = this.handleCustomDropDownClick_state.bind(this);
    this.handleCustomDropDownClick_city                    = this.handleCustomDropDownClick_city.bind(this);
    this.handleCustomDropDownClick_currency                = this.handleCustomDropDownClick_currency.bind(this);

    this.makeHTTPConn_select_COUNTRY_reload_STATE          = this.makeHTTPConn_select_COUNTRY_reload_STATE.bind(this);
    this.makeHTTPConn_select_STATE_reload_CITY             = this.makeHTTPConn_select_STATE_reload_CITY.bind(this);
    this.updateUI_select_COUNTRY_reload_CURRENCY           = this.updateUI_select_COUNTRY_reload_CURRENCY.bind(this);

    this.btn_next_act                                      = this.btn_next_act.bind(this);
    this.btn_next_act_isDisabled                           = this.btn_next_act_isDisabled.bind(this);

    this.dialog2_handleOpen                                = this.dialog2_handleOpen.bind(this);
    this.dialog2_handleClose                               = this.dialog2_handleClose.bind(this);

    this.dialog3_handleOpen                                = this.dialog3_handleOpen.bind(this);
    this.dialog3_handleClose_YES                           = this.dialog3_handleClose_YES.bind(this);
    this.dialog3_handleClose                               = this.dialog3_handleClose.bind(this);

    this.form_onChange1                                    = this.form_onChange1.bind(this);

    //[POPOVER]
    this.handlePopoverOpen_receiptDoc                      = this.handlePopoverOpen_receiptDoc.bind(this);
    this.handlePopoverClose_receiptDoc                     = this.handlePopoverClose_receiptDoc.bind(this);
  }
  //----------------------------------------------------------------------------------------------------
  componentWillMount() {
    let methName = filename+"componentWillMount ";
    if(api.print_logs){console.log(methName);}

    localStorage.setItem("prev_view", localStorage.getItem("curr_view"));
    localStorage.setItem("curr_view", filename);
    if(api.print_logs){console.log(methName+localStorage.getItem("prev_view"));}
    if(api.print_logs){console.log(methName+localStorage.getItem("curr_view")+",history.length="+history.length);}

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }
    if(!wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return;
    }
    //---------------------
    //newCustomer filtering--load Contoller---Exclude(LIGHT,BP)
    //---------------------
    if(api.new_registration_enabled){
      let parserObject_validatecustomer = {};
      try{ parserObject_validatecustomer = JSON.parse(localStorage.getItem("parserObject_validatecustomer"));}catch(err){console.log(methName+'err='+err);}
      let customerLevel = wu_Utilities.textDecisions_customerLevel(api.print_logs,parserObject_validatecustomer);
      if(customerLevel==="LIGHT"){ try {localStorage.setItem("newRegistrationFlow","newCustomer");   }catch(err){;} history.push(wu_Utilities.getNavigationURLs("RegisterLightInfo")); return; }
      if(customerLevel==="BP")   { try {localStorage.setItem("newRegistrationFlow","upgradeAccount");}catch(err){;} history.push(wu_Utilities.getNavigationURLs("RegisterLightInfo")); return; }
    }

    //[flagsimages]
    images = this.importAll(require.context('assets/img/flagspng/', false, /\.(png|svg)$/));
    //if(api.print_logs){console.log("images.length="+images.length);}
    //for (var key in images) { if(api.print_logs){console.log("key="+key);} }

    //nailed for testing:START---inactive
    //localStorage.removeItem("countries");
    //localStorage.removeItem("currencies");
    //nailed for TESTING:END

    //------------
    //getCountries---CACHED
    //------------
    let retrieveWSData_getCountries = wu_CountriesStatesCitiesService.wu_should_getCountries();
    if(retrieveWSData_getCountries){
      if(this.state.dialog200_isOpen===false){this.dialog200_handleOpen(this.NSInforString("networkerror"));} //start DialogSpinner only if network connection will take place
      wu_CountriesStatesCitiesService
      .wu_getCountries({})
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="HistoryRefund"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        //this.dialog200_handleClose();//stop DialogSpinner = NO
        if(api.print_logs){console.log("DataFrom-WebService-retrieveWSData_getCountries="+retrieveWSData_getCountries);}
        var parserObject_getCountries4Picker = [];
        res.countries = this.removeNonWuCountries(res.countries);
        res.countries = wu_Utilities.addKeywordsToJSON_test(res.countries);
        for(let i=0; i<res.countries.length; ++i){ parserObject_getCountries4Picker.push(res.countries[i]["descr_el"]); }
        this.setState({
          "parserObject_getCountries"        : res.countries,
          "parserObject_getCountries4Picker" : parserObject_getCountries4Picker
        });
      })
      .catch(err => {
        //this.dialog200_handleClose();//stop DialogSpinner = NO
        if(api.print_logs){console.log("DataFrom-SourceCode-retrieveWSData_getCountries="+retrieveWSData_getCountries);}
        console.log(methName+"err="+JSON.stringify(err));
        let res = wu_StaticDataService.wu_get_cached_countries({});
        var parserObject_getCountries4Picker= [];
        res.countries = this.removeNonWuCountries(res.countries);
        res.countries = wu_Utilities.addKeywordsToJSON_test(res.countries);
        for(let i=0; i<res.countries.length; ++i){ parserObject_getCountries4Picker.push(res.countries[i]["descr_el"]); }
        this.setState({
          "parserObject_getCountries"        : res.countries,
          "parserObject_getCountries4Picker" : parserObject_getCountries4Picker,
        });
      });
    }
    else{
      try{
        //this.dialog200_handleClose();//stop DialogSpinner = NO
        if(api.print_logs){console.log("DataFrom-Cache-retrieveWSData_getCountries="+retrieveWSData_getCountries);}
        let res = JSON.parse(localStorage.getItem("countries"));
        var parserObject_getCountries4Picker= [];
        res.countries = this.removeNonWuCountries(res.countries);
        res.countries = wu_Utilities.addKeywordsToJSON_test(res.countries);
        for(let i=0; i<res.countries.length; ++i){ parserObject_getCountries4Picker.push(res.countries[i]["descr_el"]); }
        this.setState({ "parserObject_getCountries"        : res.countries });
        this.setState({ "parserObject_getCountries4Picker" : parserObject_getCountries4Picker });
      }catch(err){
        console.log('err='+err);
      }
    }
    //-------------
    //getCurrencies---CACHED
    //-------------
    let retrieveWSData_getCurrencies = wu_CurrenciesService.wu_should_getCurrencies();
    if(retrieveWSData_getCurrencies){
      if(this.state.dialog200_isOpen===false){this.dialog200_handleOpen(this.NSInforString("networkerror"));} //start DialogSpinner only if network connection will take place
      wu_CurrenciesService
      .wu_getCurrencies({})
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="HistoryRefund"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        this.dialog200_handleClose();//stop DialogSpinner = YES
        if(api.print_logs){console.log("DataFrom-WebService-retrieveWSData_getCurrencies="+retrieveWSData_getCurrencies);}
        this.setState({ "parserObject_getCurrencies_ALL" : res.countries }); //YES! the subitem is countries!!!
      })
      .catch(err => {
        this.dialog200_handleClose();//stop DialogSpinner = YES
        if(api.print_logs){console.log("DataFrom-SourceCode-retrieveWSData_getCurrencies="+retrieveWSData_getCurrencies);}
        console.log(methName+"err="+JSON.stringify(err));
        let res = wu_StaticDataService.wu_get_cached_currencies({});
        let parserObject_getCountries4Picker= [];
        for(let i=0; i<res.countries.length; ++i){ parserObject_getCountries4Picker.push(res.countries[i]["descr_el"]); }
        this.setState({ "parserObject_getCurrencies_ALL" : res.countries }); //YES! the subitem is countries!!!
      });
    }
    else{
      try{
        this.dialog200_handleClose();//stop DialogSpinner = YES
        if(api.print_logs){console.log("DataFrom-Cache-retrieveWSData_getCurrencies="+retrieveWSData_getCurrencies);}
        let res = JSON.parse(localStorage.getItem("currencies"));
        let parserObject_getCountries4Picker= [];
        for(let i=0; i<res.countries.length; ++i){ parserObject_getCountries4Picker.push(res.countries[i]["descr_el"]); }
        this.setState({ "parserObject_getCurrencies_ALL" : res.countries }); //YES! the subitem is countries!!!
      }catch(err){
        console.log('err='+err);
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  componentDidMount() {
    let methName = filename+"componentDidMount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  componentWillUnmount() {
    let methName = filename+"componentWillUnmount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  render() {
    let methName = filename+"render ";
    if(api.print_logs){console.log(methName);}

    const classes = this.props.classes;

    //-------
    //Country
    //-------
    let defaultPropsCountry  = {};
    let filterOptionsCountry = {};
    if(this.state.picker2_textFieldLabel1_AUTOCOMPLETE_MODE === "text"){
      defaultPropsCountry  = { options:this.state.parserObject_getCountries4Picker, getOptionLabel:option => option,};
      filterOptionsCountry = createFilterOptions({matchFrom: this.state.picker1_textFieldLabel1_AUTOCOMPLETE_FILTER_OPTIONS, stringify: option => option, });
    }
    else{
      if(localStorage.getItem("lang")==="en"){ defaultPropsCountry = { options:this.state.parserObject_getCountries, getOptionLabel:option => option.descr_en ? option.descr_en : "", }; }
      else                                   { defaultPropsCountry = { options:this.state.parserObject_getCountries, getOptionLabel:option => option.descr_el ? option.descr_el : "", }; }
      filterOptionsCountry = createFilterOptions({matchFrom: this.state.picker1_textFieldLabel1_AUTOCOMPLETE_FILTER_OPTIONS,stringify: (option) => option.descr_el + option.descr_en + option.keywords,});
    }

    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={6} md={6}>

            {api.backButtonAtHeader === true ? (
              <GridContainer justify="center">
                <GridItem xs={2} sm={2} md={1}>
                  <div style={{ marginTop:20,marginBottom:10, textAlign:"left" }}>
                    {/* ----------[goBack]------------ */}
                    <Button style={{ backgroundColor:"#FFDD00" }} onClick={this.goBack}><KeyboardBackspaceIcon/></Button>
                  </div>
                </GridItem>
                <GridItem xs={10} sm={10} md={11}>
                  <div style={{ marginTop: 25 }}>
                    <div className={classes.labelHeader}>{this.NSInforString("History4_title")}</div>
                    <div className={classes.logo}><img src={logo} alt="logo" /></div>
                  </div>
                </GridItem>
              </GridContainer>
            ) : (
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12}>
                  <div style={{ marginTop: 25 }}>
                    <div className={classes.labelHeader}>{this.NSInforString("History4_title")}</div>
                    <div className={classes.logo}><img src={logo} alt="logo" /></div>
                  </div>
                </GridItem>
              </GridContainer>
            )}

            <GridContainer justify="center">
              <GridItem xs={12} sm={12} md={12}>
                <div className={classes.History4_lbl_info}>{this.NSInforString("History4_lbl_info")}</div>
              </GridItem>
            </GridContainer>
            {/* ------------------------- */}
            {/* ----------ROW------------ */}
            {/* ------------------------- */}
            <GridContainer justify="center">
              <GridItem xs={12} sm={12} md={12}>
                <TextField
                  fullWidth
                  error={this.state.textField1_hasError}
                  className={classes.textField1}
                  id="textField1"
                  label={this.NSInforString("History4_plh01")}
                  defaultValue={this.state.textField1}
                  value={this.state.textField1}
                  InputProps={{ fullWidth: true, onChange: event => this.change(event, "textField1"), type: "text" }}
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <TextField
                  fullWidth
                  error={this.state.textField2_hasError}
                  className={classes.textField2}
                  id="textField2"
                  label={this.NSInforString("History4_plh02")}
                  defaultValue={this.state.textField2}
                  value={this.state.textField2}
                  InputProps={{ fullWidth: true, onChange: event => this.change(event, "textField2"), type: "text" }}
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <TextField
                  fullWidth
                  error={this.state.textField3_hasError}
                  className={classes.textField3}
                  id="textField3"
                  label={this.NSInforString("History4_plh03")}
                  defaultValue={this.state.textField3}
                  value={this.state.textField3}
                  InputProps={{ fullWidth: true, onChange: event => this.change(event, "textField3"), type: "text" }}
                />
              </GridItem>
            </GridContainer>
            {/* ------------------------- */}
            {/* ----------ROW------------ */}
            {/* ------------------------- */}
            {this.state.picker2_textFieldLabel1_AUTOCOMPLETE_MODE === "text" ? (
            <GridContainer justify="center">
              <GridItem xs={12} sm={12} md={12}>
                <FormControl fullWidth className={classes.picker1_textFieldLabel1}>
                  <Autocomplete
                    {...defaultPropsCountry}
                    id="picker2_textFieldLabel1"
                    value={this.state.picker2_textFieldLabel1_text}
                    disableClearable
                    onChange={(event,value) => this.handleCustomDropDownClick_country(event,value)}
                    renderOption={option => {return (<React.Fragment><img src={images[wu_Utilities.findCountryIdFromCountryName(option).toLowerCase()+".png"]} alt="" width="26" height="17"/><Typography style={{ paddingLeft:10,}}>{option}</Typography></React.Fragment>);}}
                    renderInput={params => <TextField {...params} error={this.state.picker2_textFieldLabel1_hasError} label={this.NSInforString("TransferOnline_pic1")} name={"off"+Math.random()} />}
                  />
                </FormControl>
              </GridItem>
            </GridContainer>
            ) : (
            <GridContainer justify="center">
              <GridItem xs={12} sm={12} md={12}>
                <FormControl fullWidth className={classes.picker1_textFieldLabel1}>
                  <Autocomplete
                    filterOptions={filterOptionsCountry}
                    {...defaultPropsCountry}
                    id="picker2_textFieldLabel1"
                    value={this.state.picker2_textFieldLabel1_text}
                    disableClearable
                    onChange={(event,value) => this.handleCustomDropDownClick_country(event,value)}
                    renderOption={option => {return (<React.Fragment><img src={images[wu_Utilities.findCountryIdFromCountryName(option.descr_en).toLowerCase()+".png"]} alt="" width="26" height="17"/><Typography style={{ paddingLeft:10,}}>{option.descr_en}</Typography></React.Fragment>);}}
                    renderInput={params => <TextField {...params} error={this.state.picker2_textFieldLabel1_hasError} label={this.NSInforString("TransferOnline_pic1")} name={"off"+Math.random()} />}
                  />
                </FormControl>
              </GridItem>
            </GridContainer>
            ) }
            {/* ------------------------- */}
            {/* ----------ROW------------ */}
            {/* ------------------------- */}
            {this.state.viewStateCity_isHidden === true ? ( "" ) : (
              <GridContainer justify="center">
                <GridItem xs={6} sm={6} md={6}>
                  <FormControl fullWidth error={this.state.picker4_textFieldLabel1_hasError} className={classes.picker4_textFieldLabel1}>
                    <InputLabel id="picker4_textFieldLabel1_InputLabel">{this.NSInforString("TransferOnline_pic4")}</InputLabel>
                    <Select
                      displayEmpty
                      id="picker4_textFieldLabel1"
                      value={this.state.picker4_textFieldLabel1_text}
                      onChange={event => this.handleCustomDropDownClick_state(event)}
                    >
                      {this.state.parserObject_getStates4Picker.map(function (akey) {
                        return <MenuItem key={akey} value={akey}>{akey}</MenuItem>;
                      })}
                    </Select>
                  </FormControl>
                </GridItem>
                {this.state.viewCity_isHidden === true ?
                  <GridItem xs={6} sm={6} md={6}>
                  </GridItem>
                  :
                  (
                  <GridItem xs={6} sm={6} md={6}>
                    <FormControl fullWidth error={this.state.picker5_textFieldLabel1_hasError} className={classes.picker5_textFieldLabel1}>
                      <InputLabel id="picker5_textFieldLabel1_InputLabel">{this.NSInforString("TransferOnline_pic5")}</InputLabel>
                      <Select
                        displayEmpty
                        id="picker5_textFieldLabel1"
                        value={this.state.picker5_textFieldLabel1_text}
                        onChange={event => this.handleCustomDropDownClick_city(event)}
                      >
                        {this.state.parserObject_getCities4Picker.map(function (akey) {
                          return <MenuItem value={akey}>{akey}</MenuItem>;
                        })}
                      </Select>
                    </FormControl>
                  </GridItem>
                  )}
              </GridContainer>
            )}
            {/* ------------------------- */}
            {/* ----------ROW------------ */}
            {/* ------------------------- */}
            <GridContainer justify="center">
              <GridItem xs={12} sm={12} md={12}>
                <FormControl fullWidth error={this.state.picker3_textFieldLabel1_hasError} className={classes.picker3_textFieldLabel1}>
                  <InputLabel id="picker3_textFieldLabel1_InputLabel">{this.NSInforString("TransferOnline_pic3")}</InputLabel>
                  <Select
                    displayEmpty
                    id="picker3_textFieldLabel1"
                    value={this.state.picker3_textFieldLabel1_text}
                    onChange={event => this.handleCustomDropDownClick_currency(event)}
                  >
                    {this.state.parserObject_getCurrencies4Picker.map(function (akey) {
                      return <MenuItem key={akey} value={akey}>{akey}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              </GridItem>
            </GridContainer>
            {/* ------------------------- */}
            {/* ----------ROW------------ */}
            {/* ------------------------- */}
            <GridContainer justify="center">
              <GridItem xs={10} sm={10} md={10}>
                <div className={classes.History4_lbl_receipt_plh}>{this.NSInforString("History4_plh06")}</div>
                <div className={classes.History4_plh06b}>{this.NSInforString("History4_plh06b")}</div>
                <div style={{ width:"100%" }}><input style={{ width:"100%" }} id="form_input_value1" type="file" accept="application/pdf" onChange={this.form_onChange1} /></div>
              </GridItem>
              <GridItem xs={2} sm={2} md={2} id="receiptDocAnchor">
                <div className={classes.History4_lbl_receipt_plh}>&nbsp;</div>
                <div style={{ textAlign:"right" }}>
                  <IconButton onClick={this.handlePopoverOpen_receiptDoc} onMouseDown={this.handlePopoverOpen_receiptDoc} style={{padding:0}}><InfoIcon/></IconButton>
                </div>
                {/* <Divider light={false} style={{ backgroundColor:"#303030 !important" }}/> */}

                {/* ------------------------- */}
                {/* ----------[POPOVER]------ */}
                {/* ------------------------- */}
                <Popover
                  id="receiptDoc_popover"
                  className={classes.popover}
                  classes={{ paper:classes.paper }}
                  open={this.state.receiptDoc_popover_isOpen}
                  anchorEl={document.getElementById("receiptDocAnchor")}
                  anchorOrigin={{ vertical:'bottom', horizontal:'left' }}
                  transformOrigin={{ vertical:'top', horizontal:'left' }}
                  onClose={this.handlePopoverClose_receiptDoc}
                  disableRestoreFocus
                >
                  <Typography style={{width:280, padding:5}}>{this.NSInforString("History4_popover_receiptdoc")}</Typography>
                </Popover>
              </GridItem>
            </GridContainer>
            {/* ------------------------- */}
            {/* ----------[SPINNERS]----- */}
            {/* ------------------------- */}
            {this.state.viewPleaseWait_hidden === true ? ( "" ) : (
              <GridContainer justify="center">
                <GridItem xs={3} sm={3} md={3}></GridItem>
                <GridItem xs={6} sm={6} md={6}>
                  <div className={classes.pleaseWait}><CircularProgress/><span>&nbsp;{this.NSInforString("please_wait")}</span></div>
                </GridItem>
                <GridItem xs={3} sm={3} md={3}></GridItem>
              </GridContainer>
            )}
            {/* ------------------------- */}
            {/* ----------[BUTTONS]------ */}
            {/* ------------------------- */}
            <GridContainer justify="center">
              <GridItem xs={10} sm={10} md={10}>
                <div className={classes.textCenter}>
                  <CustomButton
                    disabled={this.btn_next_act_isDisabled()}
                    className={classes.yellowButton}
                    color="rose"
                    onClick={this.btn_next_act}
                    type="submit">
                    {this.NSInforString("History4_btn_next")}
                  </CustomButton>
                </div>
              </GridItem>
            </GridContainer>
            {/* -------------------------------------------------- */}
            {/* ----------[goBack Bottom]------------------------- */}
            {/* -------------------------------------------------- */}
            {api.backButtonAtBottom === true ? (
              <GridContainer justify="center">
                <GridItem xs={10} sm={10} md={10}>
                  <div className={classes.textCenter}>
                    <CustomButton
                      disabled={false}
                      className={classes.backButton}
                      color="rose"
                      onClick={this.goBack}>
                      {this.NSInforString("History4_btn_prev")}
                    </CustomButton>
                  </div>
                </GridItem>
              </GridContainer>
            ) : ( "" ) }

          </GridItem>
        </GridContainer>
        {/* ------------------------- */}
        {/* ----------[SNACKBAR]----- */}
        {/* ------------------------- */}
        <Snackbar open={this.state.Snackbar_textField_open} autoHideDuration={api.snackBarDurationMS} onClose={this.Snackbar_textField_handleClose}>
          <Alert onClose={this.Snackbar_textField_handleClose} severity="error">{this.state.Snackbar_textField_msg}</Alert>
        </Snackbar>
        {/* ------------------------- */}
        {/* ----------[POPUP]-------- */}
        {/* ------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">{this.state.dialog_msg}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog_handleClose}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* ---------------------------- */}
        {/* ----------[DialogSpinner]--- */}
        {/* ---------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog200_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog200_handleClose}
            aria-labelledby="alert-dialog200-slide-title"
            aria-describedby="alert-dialog200-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <div className={classes.pleaseWaitPopup}><CircularProgress/><span>&nbsp;{this.NSInforString("please_wait")}</span></div>
            </DialogContent>
          </Dialog>
        </div>
        {/* -------------------------------------------------- */}
        {/* ----------[POPUP GO BACK AFTER OK REFUND]--------- */}
        {/* -------------------------------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog2_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog2_handleClose}
            aria-labelledby="alert-dialog2-slide-title"
            aria-describedby="alert-dialog2-slide-description"
          >
            <DialogTitle id="alert-dialog2-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog2-slide-description">{this.state.dialog2_msg}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog2_handleClose}>{this.NSInforString("alert_OK")}</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* -------------------------------------------------- */}
        {/* ----------[POPUP ARE YOU SURE WITHOUT DOC]-------- */}
        {/* -------------------------------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog3_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog3_handleClose}
            aria-labelledby="alert-dialog3-slide-title"
            aria-describedby="alert-dialog3-slide-description"
          >
            <DialogTitle id="alert-dialog3-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog3-slide-description">{this.state.dialog3_msg}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog3_handleClose}>{this.NSInforString("alert_NO")}</Button>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog3_handleClose_YES}>{this.NSInforString("alert_YES")}</Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>
    );
  }
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  form_onChange1(e) {
    const methName = "form_onChange1 ";
    let ind = 0;
    if(api.print_logs){console.log("e.target.files.length="+e.target.files.length);}
    if(api.print_logs){console.log("e.target.files["+ind+"].size="+e.target.files[ind].size);}

    let hasError = false;
    //------------------
    //validate file type
    //------------------
    try{
      console.log(methName+"e.target.files["+ind+"].type="+e.target.files[ind].type);
      let ftype = e.target.files[ind].type;
      if(ftype.includes("application/pdf")===false){
        hasError = true;
        console.log(methName+"!!!!!!!!!!filetype error pdf/!!!!!!!!!! "+ftype);
        this.dialog_handleOpen(this.NSInforString("History4_errMsg_fileType"));
        try{ document.getElementById('form_input_value1').value = null; } catch (err){ console.log(methName+"err1="+err); }
        this.setState({
          "fileDocument1"     : null,
          "filePreviewSizeKB" : 0,
        });
        return;
      }
    }catch (err){ ; }
    //------------------
    //validate file size
    //------------------
    try{
      if(api.print_logs){console.log(methName+"filePreviewSizeKB="+parseInt(e.target.files[ind].size/1024) +" KB");}
      if( parseInt(e.target.files[ind].size/1024)>filePreviewSizeKB_MAX_5_0_mb ){
        hasError = true;
        console.log(methName+"!!!!!!!!!!filesize error pdf/!!!!!!!!!!");
        this.dialog_handleOpen(this.NSInforString("History4_errMsg_fileSize"));
        try{ document.getElementById('form_input_value1').value = null; } catch (err){ console.log(methName+"err2="+err); }
        this.setState({
          "fileDocument1"     : null,
          "filePreviewSizeKB" : 0,
        });
        return;
      }
    }catch (err){ ; }
    //-----------------
    //load pdf to state
    //-----------------
    try{
      if(hasError === false){
        this.setState({
          "fileDocument1"     : e.target.files[ind],
          "filePreviewSizeKB" : parseInt(e.target.files[ind].size/1024),
        });
      }
    }catch (err){
      console.log(methName+"err3="+err);
    }
  }
  //-------------------------------------------------------------------------------------------------------------------------------
  //-------------------------------------------------------------------------------------------------------------------------------
  //-------------------------------------------------------------------------------------------------------------------------------
  makeHTTPConn_select_COUNTRY_reload_STATE(ctry_wu_id){
    let methName = filename+"makeHTTPConn_select_COUNTRY_reload_STATE ";

    //------------
    //wu_getStates
    //------------
    wu_CountriesStatesCitiesService
    .wu_getStates({country:ctry_wu_id})
    .then(res => {
      if(localStorage.getItem("curr_view").trim()!=="HistoryRefund"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
      var parserObject_getStates4Picker= [];
      for(var i=0; i<res.states.length; ++i){ parserObject_getStates4Picker.push(res.states[i]["state_name"]); }
      this.setState({ "parserObject_getStates"        : res.states });
      this.setState({ "parserObject_getStates4Picker" : parserObject_getStates4Picker });
    })
    .catch(err => {
      console.log(methName+"err="+JSON.stringify(err));
    });

    if(ctry_wu_id === "US"){this.setState({ "viewState_isHidden":false }); this.setState({ "viewCity_isHidden":true });}//before select state do not show city
    if(ctry_wu_id === "MX"){this.setState({ "viewState_isHidden":false }); this.setState({ "viewCity_isHidden":true });}
    this.setState({ "viewStateCity_isHidden":false });

    //repeat transaction
    //if(mainDelegate.parserObject_transhistorydetail_unique!=null){
    //    [self buildUI_repeatTrans_state_selectItemOnPicker];
    //}

    return;
  }
  //-------------------------------------------------------------------------------------------------------------------------------
  makeHTTPConn_select_STATE_reload_CITY(){
    let methName = filename+"makeHTTPConn_select_STATE_reload_CITY ";

    let ctry_wu_id = this.state.picker2_textFieldLabel1_id;
    let state_id   = this.state.picker4_textFieldLabel1_id;

    //------------
    //wu_getCities
    //------------
    wu_CountriesStatesCitiesService
    .wu_getCities({country:ctry_wu_id,state:state_id})
    .then(res => {
      if(localStorage.getItem("curr_view").trim()!=="HistoryRefund"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
      var parserObject_getCities4Picker= [];
      for(var i=0; i<res.cities.length; ++i){ parserObject_getCities4Picker.push(res.cities[i]["state_name"]); }
      this.setState({ "parserObject_getCities"        : res.cities });
      this.setState({ "parserObject_getCities4Picker" : parserObject_getCities4Picker });
    })
    .catch(err => {
      console.log(methName+"err="+JSON.stringify(err));
    });

    if(ctry_wu_id === "US"){this.setState({ "viewState_isHidden":false }); this.setState({ "viewCity_isHidden":true  });}//before select state do not show city
    if(ctry_wu_id === "MX"){this.setState({ "viewState_isHidden":false }); this.setState({ "viewCity_isHidden":false });}
    this.setState({ "viewStateCity_isHidden":false });

    return;
  }
  //----------------------------------------------------------------------------------------------------
  updateUI_select_COUNTRY_reload_CURRENCY(ctry_wu_id){
    let methName = filename+"updateUI_select_COUNTRY_reload_CURRENCY ";
    if(api.print_logs){console.log(methName+'ctry_wu_id='+ctry_wu_id);}

    for (let i=0; i<this.state.parserObject_getCurrencies_ALL.length && ctry_wu_id !==""; ++i) {
        let item = this.state.parserObject_getCurrencies_ALL[i];
        if(ctry_wu_id === item.ctry_wu_id){
            let countryCurrencies = item["currencies"];
            if(countryCurrencies.length===1){
                //localStorage.setItem("parserObject_getCurrencies4CountryRec_isD2B",    item[api.hasD2BfName]===true?"true":"false");
                //localStorage.setItem("parserObject_getCurrencies4CountryRec_localCur", item["localCur"]);
                //this.setState({ "viewTM_view_BA_isHidden" : (item[api.hasD2BfName]===true) ? false : true });

                let parserObject_getCurrencies4Picker= [];
                for(let ii=0; ii<countryCurrencies.length; ++ii){ parserObject_getCurrencies4Picker.push(countryCurrencies[ii]["curr_descr"]); }
                this.setState({
                  "parserObject_getCurrencies"       : countryCurrencies,
                  "parserObject_getCurrencies4Picker": parserObject_getCurrencies4Picker,
                  "picker3_selIndex_currencyReceive" : 0,
                  "picker3_textFieldLabel1_id"       : countryCurrencies[0]["curr_iso_id"],
                  "picker3_textFieldLabel1_text"     : countryCurrencies[0]["curr_descr"],
                  "picker3_textFieldLabel1_hasError" : false,
                });
                if(api.print_logs){console.log('[1] ctry_wu_id='+ctry_wu_id+',parserObject_getCurrencies4Picker='+parserObject_getCurrencies4Picker);}
            }
            else if(countryCurrencies.length>1){
                //localStorage.setItem("parserObject_getCurrencies4CountryRec_isD2B",    item[api.hasD2BfName]===true?"true":"false");
                //localStorage.setItem("parserObject_getCurrencies4CountryRec_localCur", item["localCur"]);
                //this.setState({ "viewTM_view_BA_isHidden" : (item[api.hasD2BfName]===true) ? false : true });

                //5Α16
                //countryCurrencies = [{curr_iso_id:"",curr_descr:this.NSInforString("TransferOnline_pic3")}].concat(countryCurrencies);

                let parserObject_getCurrencies4Picker= [];
                for(let ii=0; ii<countryCurrencies.length; ++ii){ parserObject_getCurrencies4Picker.push(countryCurrencies[ii]["curr_descr"]); }
                this.setState({
                  "parserObject_getCurrencies"       : countryCurrencies,
                  "parserObject_getCurrencies4Picker": parserObject_getCurrencies4Picker,
                  "picker3_selIndex_currencyReceive" : 0,
                  "picker3_textFieldLabel1_id"       : countryCurrencies[0]["curr_iso_id"],
                  "picker3_textFieldLabel1_text"     : countryCurrencies[0]["curr_descr"],
                  "picker3_textFieldLabel1_hasError" : false,
                });
                if(api.print_logs){console.log('[1] ctry_wu_id='+ctry_wu_id+',parserObject_getCurrencies4Picker='+parserObject_getCurrencies4Picker);}
            }
            break;
        }
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Drop Down Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  handleCustomDropDownClick_country(event,value) {
    let methName = filename+"handleCustomDropDownClick_country ";
    let event_target_value = null;
    let eventTMP1          = null;
    let eventTMP2          = null;
    if(this.state.picker2_textFieldLabel1_AUTOCOMPLETE_MODE === "text"){
      event_target_value = (event.target.value===null || (typeof event.target.value === "undefined")) ? "" : event.target.value;
      eventTMP1          = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value;
      eventTMP2          = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value;
    }
    else{
      event_target_value = (event.target.value===null || (typeof event.target.value === "undefined")) ? "" : event.target.value;
      eventTMP1          = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value;
      eventTMP2          = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value.descr_en;
    }
    if(api.print_logs){console.log(methName+"eventTMP1 = " + eventTMP1);}
    if(api.print_logs){console.log(methName+"eventTMP2 = " + eventTMP2);}
    if(api.print_logs){console.log(methName+"event     = " + event);}
    if(api.print_logs){console.log(methName+"value     = " + value);}

    this.setState({
      "picker2_textFieldLabel1_text"     : eventTMP1,
      "picker2_textFieldLabel1_hasError" : (eventTMP2.trim() === "") ? true : false,
    });
    for(let i=0; i<this.state.parserObject_getCountries4Picker.length; ++i){
      if(this.state.parserObject_getCountries4Picker[i]===eventTMP2){
        this.setState({
          "picker2_selIndex"           : i,
          "picker2_textFieldLabel1_id" : this.state.parserObject_getCountries[i].ctry_wu_id
        });
        let ctry_wu_id_TMP = this.state.parserObject_getCountries[i].ctry_wu_id;
        this.updateUI_select_COUNTRY_reload_CURRENCY(ctry_wu_id_TMP);
        if(ctry_wu_id_TMP==="US" || ctry_wu_id_TMP==="MX"){
          this.makeHTTPConn_select_COUNTRY_reload_STATE(ctry_wu_id_TMP);
        }
        else{
          this.setState({ "viewStateCity_isHidden":true });
        }
        break;
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  handleCustomDropDownClick_state(event) {
    let methName = filename+"handleCustomDropDownClick_state ";
    let eventTMP = event.target.value+"";
    if(api.print_logs){console.log(methName+eventTMP);}
    this.setState({
      "picker4_textFieldLabel1_text"     : eventTMP,
      "picker4_textFieldLabel1_hasError" : (eventTMP.trim() === "") ? true : false,
    });
    for(let i=0; i<this.state.parserObject_getStates4Picker.length; ++i){
      if(this.state.parserObject_getStates4Picker[i]===eventTMP){
        this.setState({
          "picker4_selIndex_State"     : i,
          "picker4_textFieldLabel1_id" : this.state.parserObject_getStates[i].state_name
        });
        break;
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  handleCustomDropDownClick_city(event) {
    let methName = filename+"handleCustomDropDownClick_city ";
    let eventTMP = event.target.value+"";
    if(api.print_logs){console.log(methName+eventTMP);}
    this.setState({
      "picker5_textFieldLabel1_text"     : eventTMP,
      "picker5_textFieldLabel1_hasError" : (eventTMP.trim() === "") ? true : false,
    });
    for(let i=0; i<this.state.parserObject_getCities4Picker.length; ++i){
      if(this.state.parserObject_getCities4Picker[i]===eventTMP){
        this.setState({
          "picker5_selIndex_City"      : i,
          "picker5_textFieldLabel1_id" : this.state.parserObject_getCities[i].ctry_wu_id
        });
        break;
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  handleCustomDropDownClick_currency(event) {
    let methName = filename+"handleCustomDropDownClick_currency ";
    let eventTMP = event.target.value+"";
    if(api.print_logs){console.log(methName+eventTMP);}
    this.setState({
      "picker3_textFieldLabel1_text"     : eventTMP,
      "picker3_textFieldLabel1_hasError" : (eventTMP.trim() === "") ? true : false,
    });
    for(let i=0; i<this.state.parserObject_getCurrencies4Picker.length; ++i){
      if(this.state.parserObject_getCurrencies4Picker[i]===eventTMP){
        this.setState({ "picker3_selIndex_currencyReceive" :  i });
        this.setState({ "picker3_textFieldLabel1_id"       :  this.state.parserObject_getCurrencies[i].curr_iso_id });
        break;
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Button Listeners----------------------------------
  //----------------------------------------------------------------------------------------------------
  btn_next_act_isDisabled(){
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  btn_next_act(){
    let methName = filename+"btn_next_act ";
    if(api.print_logs){console.log(methName);}

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }
    //+++++++++++++++++++++++
    //validate Only Emptyness
    //+++++++++++++++++++++++
    let validateOnlyEmptyness = true;
    if(validateOnlyEmptyness){
      let emptyFields = false;
      if(this.state.textField1.trim() === "") { this.setState({"textField1_hasError" : true }); emptyFields = true; }
      if(this.state.textField2.trim() === "") { this.setState({"textField2_hasError" : true }); emptyFields = true; }
      if(this.state.textField3.trim() === "") { this.setState({"textField3_hasError" : true }); emptyFields = true; }

      if(this.state.picker2_textFieldLabel1_text ==="") { this.setState({"picker2_textFieldLabel1_hasError" : true }); emptyFields = true; } //picker2_textFieldLabel1_AUTOCOMPLETE_MODE(do not trim)
      if(this.state.picker3_textFieldLabel1_text ==="") { this.setState({"picker3_textFieldLabel1_hasError" : true }); emptyFields = true; }
      if(this.state.viewState_isHidden===false){
        if(this.state.picker4_textFieldLabel1_text ==="") { this.setState({"picker4_textFieldLabel1_hasError" : true }); emptyFields = true; }
      }
      if(this.state.viewCity_isHidden===false){
        if(this.state.picker5_textFieldLabel1_text ==="") { this.setState({"picker5_textFieldLabel1_hasError" : true }); emptyFields = true; }
      }
      if(emptyFields===true){return;}
    }



    let aRow = {};
    try { aRow = JSON.parse(localStorage.getItem("parserObject_transhistorydetail")); }catch(err){;}
    let transactionId = "";
    try {transactionId = aRow["trans_id"]; }catch(err){;}
    if(transactionId === null || (typeof transactionId === "undefined")){transactionId= ""; }
    //-------------
    //validate mtcn---TextField
    //-------------
    let mtcn           = this.state.textField1.trim();
    let textField1text = this.state.textField1.trim();
    if(textField1text === ""){
      this.setState({"textField1_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("History4_plh01")+"\"");
      return;
    }
    if(this.verifyGenericItem("MTCN",textField1text)===false){
      this.setState({"textField1_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("common.mtcn.digits"));
      return;
    }
    //--------------------------
    //validate receiverFirstName---TextField
    //--------------------------
    let receiverFirstName = this.state.textField2.trim();
    let textField2text    = this.state.textField2.trim();
    if(textField2text === ""){
      this.setState({"textField2_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("History4_plh02")+"\"");
      return;
    }
    if(wu_Utilities.offline_validate_latinCharacters(textField2text.replace(/ /g,""))===false){
      this.setState({"textField2_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("History4_plh02")+"\" "+this.NSInforString("with_latin"));
      return;
    }
    if(textField2text.length < 2 || textField2text.length > 36){
      this.setState({"textField2_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("common.firstName.size"));
      return;
    }
    //-------------------------
    //validate receiverLastName---TextField
    //-------------------------
    let receiverLastName = this.state.textField3.trim();
    let textField3text   = this.state.textField3.trim();
    if(textField3text === ""){
      this.setState({"textField3_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("History4_plh03")+"\"");
      return;
    }
    if(wu_Utilities.offline_validate_latinCharacters(textField3text.replace(/ /g,""))===false){
      this.setState({"textField3_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("History4_plh03")+"\" "+this.NSInforString("with_latin"));
      return;
    }
    if(textField3text.length < 2 || textField3text.length > 36){
      this.setState({"textField3_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("common.lastName.size"));
      return;
    }
    //---------------------------
    //validate firstName+lastName---TextField
    //---------------------------
    if(textField2text.length + textField3text.length > 39){
      this.setState({"textField2_hasError" : true });
      this.setState({"textField3_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("common.firstlastName.size"));
      return;
    }
    //--------------------
    //validate countryWuId---Picker
    //--------------------
    let countryWuId = this.state.picker2_textFieldLabel1_id;
    if(countryWuId ===""){
      this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("History4_pic2"));
      return;
    }
    //--------------
    //validate State
    //--------------
    let stateId = "";
    if(this.state.viewState_isHidden === false){
      let state_id = this.state.picker4_textFieldLabel1_id;
      if(state_id === ""){
          this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("History4_pic4"));
          return;
      }
    }
    //-------------
    //validate City
    //-------------
    // let city_id = "";
    // if(this.state.viewCity_isHidden === false){
    //   let city_id = this.state.picker5_textFieldLabel1_id;
    //   if(city_id === ""){
    //       this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("History4_pic5"));
    //       return;
    //   }
    // }
    //-----------------
    //validate currency
    //-----------------
    let receiverCurrencyId = this.state.picker3_textFieldLabel1_id;
    if(receiverCurrencyId === ""){
      this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("History4_pic3"));
      return;
    }

    if(api.print_logs){console.log("mtcn               = "+mtcn);               }
    if(api.print_logs){console.log("receiverFirstName  = "+receiverFirstName);  }
    if(api.print_logs){console.log("receiverLastName   = "+receiverLastName);   }
    if(api.print_logs){console.log("countryWuId        = "+countryWuId);        }
    if(api.print_logs){console.log("stateId            = "+stateId);            }
    if(api.print_logs){console.log("receiverCurrencyId = "+receiverCurrencyId); }

    let parserObject_refundTransaction_req = {};
    parserObject_refundTransaction_req["transactionId"]      = transactionId;      //transactionId
    parserObject_refundTransaction_req["mtcn"]               = mtcn;               //324434
    parserObject_refundTransaction_req["receiverFirstName"]  = receiverFirstName;  //Nikos
    parserObject_refundTransaction_req["receiverLastName"]   = receiverLastName;   //Menis
    parserObject_refundTransaction_req["countryWuId"]        = countryWuId;        //GR
    parserObject_refundTransaction_req["stateId"]            = stateId;            //M
    parserObject_refundTransaction_req["receiverCurrencyId"] = receiverCurrencyId; //
    parserObject_refundTransaction_req["uploadDocId"]        = 0;

    if(this.state.filePreviewSizeKB===0){
      localStorage.setItem("parserObject_refundTransaction_req", JSON.stringify(parserObject_refundTransaction_req));
      this.dialog3_handleOpen(this.NSInforString("History4_confirm_continue_without_receipt"));
    }
    else{
      this.startSpinners();
      setTimeout(function() { //Start the timer
        //-------------------------
        //wu_onlinemt_uploadreceipt
        //-------------------------
        wu_OnlineMTService
        .wu_onlinemt_uploadreceipt(this.state.fileDocument1)
        .then(res => {
          if(localStorage.getItem("curr_view").trim()!=="HistoryRefund"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
          //this.stopSpinners();
          //console.log(methName+"res="+JSON.stringify(res));
          document.getElementById('form_input_value1').value = null;

          let uploadDocId = 0;
          try{
              let returnText = "";
              try {returnText = res.returnText; }catch(err){console.log(methName+"err1="+JSON.stringify(err));}
              if(returnText===null || (typeof returnText === "undefined")){returnText = "";}
              if(returnText!==""){
                  uploadDocId = parseInt(returnText);
              }
          }catch(err){console.log(methName+"err2="+JSON.stringify(err));}
          parserObject_refundTransaction_req["uploadDocId"] = uploadDocId;
          //--------------------
          //wu_refundTransaction
          //--------------------
          wu_HistoryService
          .wu_refundTransaction(parserObject_refundTransaction_req)
          .then(res => {
            if(localStorage.getItem("curr_view").trim()!=="HistoryRefund"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
            this.stopSpinners();
            this.dialog2_handleOpen(this.NSInforString("History4_successMessage"));
          })
          .catch(err => {
            this.stopSpinners();
            console.log(methName+"err="+JSON.stringify(err));
            if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText,"NET"); }
            else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
          });
        })
        .catch(err => {
          this.stopSpinners();
          if(api.print_logs){console.log(methName+"err="+JSON.stringify(err));}
          if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText,"NET"); }
          else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
        });
      }.bind(this), 500);
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------TextField Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  change(event, stateVar) {
    let eventTMP = event.target.value+"";
    //if(api.print_logs){console.log(stateVar+" "+eventTMP);}

    // if(api.allow_hp_to_be_edited===true && stateVar==="textField0"){ //[HONEYMOON]
    //   this.setState({"textField0":eventTMP.trim(),});
    // }
    if(stateVar==="textField1"){
      this.setState({
        "textField1"          : eventTMP,
        "textField1_hasError" : (eventTMP.trim() === "") ? true : false,
      });
      if(eventTMP.length>0 && wu_Utilities.offline_validate_numericCharacters(eventTMP.replace(/ /g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.digits")); this.setState({"textField1_hasError":true}); return; }
    }
    else if(stateVar==="textField2"){
      eventTMP = eventTMP.toUpperCase();
      this.setState({
        "textField2"          : eventTMP,
        "textField2_hasError" : (eventTMP.trim() === "") ? true : false,
      });
      if(eventTMP.length>0 && wu_Utilities.offline_validate_latinCharacters(eventTMP.replace(/ /g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin")); this.setState({"textField2_hasError":true}); return; }
      if(eventTMP.length > 36){ this.Snackbar_textField_handleOpen(this.NSInforString("common.firstName.size")); this.setState({"textField2_hasError":true}); return; }
      if(eventTMP.trim().length + this.state.textField3.trim().length > 39){ this.Snackbar_textField_handleOpen(this.NSInforString("common.firstlastName.size")); this.setState({"textField2_hasError":true, "textField3_hasError":true}); return; }
      else                                                                 { this.setState({"textField2_hasError":false, "textField3_hasError":false}); }
    }
    else if(stateVar==="textField3"){
      eventTMP = eventTMP.toUpperCase();
      this.setState({
        "textField3"          : eventTMP,
        "textField3_hasError" : (eventTMP.trim() === "") ? true : false,
      });
      if(eventTMP.length>0 && wu_Utilities.offline_validate_latinCharacters(eventTMP.replace(/ /g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin")); this.setState({"textField3_hasError":true}); return; }
      if(eventTMP.length > 36){ this.Snackbar_textField_handleOpen(this.NSInforString("common.lastName.size")); this.setState({"textField3_hasError":true}); return; }
      if(this.state.textField2.trim().length + eventTMP.trim().length > 39){ this.Snackbar_textField_handleOpen(this.NSInforString("common.firstlastName.size")); this.setState({"textField2_hasError":true, "textField3_hasError":true}); return; }
      else                                                                 { this.setState({"textField2_hasError":false, "textField3_hasError":false}); }
    }
    else{
      this.setState({ [stateVar]:eventTMP });
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Utilities-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  NSInforString = aKey => {
    if(localStorage.getItem("lang")==="en"){ return this.texts_en[aKey] ? this.texts_en[aKey] : ""; }
    else                                   { return this.texts_gr[aKey] ? this.texts_gr[aKey] : ""; }
  };
  //----------------------------------------------------------------------------------------------------
  verifyLength(value, length) {
    if (value && value.length >= length) { return true; }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  verifyGenericItem(key,val) {
    if(key==="MTCN")                             { return wu_Utilities.wu_verifyMTCN(val);  }
    if(key==="firstName")                        { return wu_Utilities.offline_validate_firstName(val); }
    if(key==="lastName")                         { return wu_Utilities.offline_validate_lastName(val);  }

    return false;
  }
  importAll(r) {
    //return r.keys().map(r);
    let images = {};
    r.keys().map((item, index) => {
      images[item.replace('./', '')] = r(item);
      return "";
    });
    return images;
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[goBack]------------------------------------------
  //----------------------------------------------------------------------------------------------------
  goBack(event) {
    //history.go(-1);
    history.goBack();
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups--------------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog_handleOpen(dialog_msg,dType){
    if(dType==="NET"){
      setTimeout(function() {
        this.setState({
          "dialog_isOpen" : true,
          "dialog_msg"    : dialog_msg
        });
      }.bind(this), api.initialLoadGracePeriodMS);
      return;
    }
    this.setState({
      "dialog_isOpen" : true,
      "dialog_msg"    : dialog_msg
    });
  }
  dialog_handleClose(){
    this.setState({ "dialog_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups2--------------------------------------------
  //--------------------------------------------------------------- -------------------------------------
  dialog2_handleOpen(dialog2_msg){
    this.setState({ "dialog2_isOpen" : true });
    this.setState({ "dialog2_msg"    : dialog2_msg });
  }
  dialog2_handleClose(){
    this.setState({ "dialog2_isOpen": false });
    //history.go(-1);
    history.goBack();
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups3-------------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog3_handleOpen(dialog3_msg){
    this.setState({ "dialog3_isOpen" : true });
    this.setState({ "dialog3_msg"    : dialog3_msg });
  }
  dialog3_handleClose_YES(){
    let methName = filename+"dialog3_handleClose_YES ";
    if(api.print_logs){console.log(methName);}

    this.setState({ "dialog3_isOpen": false });

    this.startSpinners();
    setTimeout(function() { //Start the timer
      //--------------------
      //wu_refundTransaction
      //--------------------
      let parserObject_refundTransaction_req = JSON.parse(localStorage.getItem("parserObject_refundTransaction_req"));

      wu_HistoryService
      .wu_refundTransaction(parserObject_refundTransaction_req)
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="HistoryRefund"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        this.stopSpinners();
        this.dialog2_handleOpen(this.NSInforString("History4_successMessage"));
      })
      .catch(err => {
        this.stopSpinners();
        console.log(methName+"err="+JSON.stringify(err));
        if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText,"NET"); }
        else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
      });
    }.bind(this), 500);
  }
  dialog3_handleClose(){
    let methName = filename+"dialog3_handleClose ";
    if(api.print_logs){console.log(methName);}

    this.setState({ "dialog3_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[SNACKBAR]----------------------------------------
  //----------------------------------------------------------------------------------------------------
  Snackbar_textField_handleOpen(msg){
    this.setState({
      "Snackbar_textField_open" : true,
      "Snackbar_textField_msg"  : msg,
    });
  }
  Snackbar_textField_handleClose(){
    this.setState({ "Snackbar_textField_open" : false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[POPOVER]-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  handlePopoverOpen_receiptDoc(){
    this.setState({ "receiptDoc_popover_isOpen" : true, });
  }
  handlePopoverClose_receiptDoc(){
    this.setState({ "receiptDoc_popover_isOpen" : false, });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Spinners------------------------------------------
  //----------------------------------------------------------------------------------------------------
  startSpinners(){
    this.setState({ "viewPleaseWait_hidden" : false });
  }
  //----------------------------------------------------------------------------------------------------
  stopSpinners(){
    this.setState({ "viewPleaseWait_hidden" : true });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------DialogSpinner-------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog200_handleOpen(dialog_msg){
    this.setState({
      "dialog200_isOpen" : true,
      "dialog200_msg"    : dialog_msg
    });
  }
  //----------------------------------------------------------------------------------------------------
  dialog200_handleClose(){
    //this.setState({ "dialog200_isOpen": false });
    setTimeout(function() {
      this.setState({ "dialog200_isOpen": false });
    }.bind(this), api.initialLoadGracePeriodMS);
  }
  //----------------------------------------------------------------------------------------------------
  removeNonWuCountries(countries){
    let countriesNew = [];
    for(let i=0; i<countries.length; ++i){
      if(countries[i].isWu===true){countriesNew.push(countries[i]);}
    }
    if(countriesNew.length===0){return countries;}
    return countriesNew;
  }
  //----------------------------------------------------------------------------------------------------
}
HistoryRefund.propTypes = {
  classes: PropTypes.object.isRequired
};
function mapStateToProps(state) {
  const { alert }    = state;
  const { dispatch } = state;
  return {
    dispatch,
    alert
  };
}
export default connect(mapStateToProps)(
  withStyles(HistoryRefundStyle)(HistoryRefund)
);
